import { userConstants } from "../constants";

let user = JSON.parse(localStorage.getItem("user"));
const initialState = user ? { loggedIn: true, user } : {};

export function authentication(state = initialState, action) {
  switch (action.type) {
    case userConstants.LOGIN_REQUEST:
      return {
        loggingIn: true,
        user: action.payload
      };
    case userConstants.LOGIN_SUCCESS:
      return {
        loggedIn: true,
        user: action.payload
      };
    case userConstants.LOGIN_FAILURE:
      return {
        error: action.payload.errorMessage
      };
    case userConstants.RESET_PASSWORD_SUCCESS:
      return {
        error:
          "A link to reset your password has been sent to the account you provided."
      };
    case userConstants.LOGOUT:
      return {};
    default:
      return state;
  }
}

export default authentication;
